/*
* @Author: Joana 'dygon' Oliveira
* @Date:   2021-10-20 08:40:03
* @Last Modified by:   Joana 'dygon' Oliveira
* @Last Modified time: 2021-10-20 08:55:55
*/


jQuery(document).ready(function($) {
	

	// add elemnt to popup and openen it
	jQuery('.addToPopUp').click(function(event) {
		if( jQuery(this).is('img') ) {
  			var html = '<img class="cortain__contentImage" src="' + jQuery(this).attr('src') + '">';
		} else {
			var html = jQuery(this);
		}    	
    	jQuery('.cortain__content').html(html);
    	jQuery('.cortain').addClass('cortain--open');
    });

    // close popup
	jQuery('.cortain').click(function(event) { 
		var container = jQuery('.cortain');
		if( container.is(event.target) ){
        	container.removeClass('cortain--open');
        	jQuery('.cortain__content').html('');
    	}
	});

});	